import { getBillingInfoService } from 'services/billing/getBillingInfo';
import { getAuthorization } from './controller';

export const getBillingInfo = async (planId = '') => {
  const authorization = getAuthorization();

  const { data } = await getBillingInfoService(authorization, planId);

  return data && data.planDetailsList ? data.planDetailsList[0] : null;
};
